import React from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner, EmptyState } from '@opendate-app/setlist';
import crmLabels from '../../shared/utils/crmLabels';

const ICON = { user: 'far fa-user', deal: 'far fa-file-invoice-dollar', check: 'far fa-check-circle', note: 'far fa-sticky-note' };

function relTime(at) {
  if (!at) return '';
  const diff = Math.max(0, Date.now() - new Date(at).getTime());
  const mins = Math.round(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return new Date(at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

function RecentActivity({ activity, loading, labels = crmLabels(undefined) }) {
  const rows = activity || [];
  return (
    <Card padding="md">
      <div className="mb-3"><strong>Recent activity</strong></div>

      {loading && <div className="d-flex justify-content-center py-4"><Spinner label="Loading…" /></div>}

      {!loading && rows.length === 0 && (
        <EmptyState
          size="sm"
          title="No activity yet"
          description={`Emails, calls, ${labels.deal.singular.toLowerCase()} updates, and completed tasks show up here as your team works.`}
        />
      )}

      {!loading && rows.map((item, i) => (
        <div key={`${item.icon}-${item.at}-${i}`} className="d-flex py-2" style={{ gap: 10 }}>
          <i className={`${ICON[item.icon] || 'far fa-circle'} text-muted`} style={{ marginTop: 3 }} />
          <div className="crm-dash__truncate">
            <div>{item.href ? <a href={item.href}>{item.title}</a> : item.title}</div>
            <div className="text-muted small">{[item.subtitle, relTime(item.at)].filter(Boolean).join(' · ')}</div>
          </div>
        </div>
      ))}
    </Card>
  );
}

RecentActivity.propTypes = {
  activity: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  labels: PropTypes.object,
};

export default RecentActivity;
